import { Dispatch, createContext, useContext } from "react";
import { IAddress, IAddressBusinessEntity } from "../../../types/address";
import { Action } from "../../../types/reducer-action";
import { DataEntryState, dataEntryReducer } from "../../common/data-entry-reducer";

export enum AddressManagerDomain {
  BusinessEntities = 'businessEntities'
}

export interface AddressForm extends IAddress {
  postalCode?: string;
}

export interface AddressState extends DataEntryState<IAddress, AddressForm> {
  subdomains: {
    [AddressManagerDomain.BusinessEntities]?: DataEntryState<IAddressBusinessEntity, IAddressBusinessEntity>
  }
}

export const addressReducer = (state: AddressState, action: Action): AddressState =>
  dataEntryReducer<IAddress, IAddress>(state, action);

export const AddressContext = createContext<AddressState>({} as AddressState);
export const useAddressState = () => useContext(AddressContext);

export const AddressDispatchContext = createContext<Dispatch<Action>>(() => { });
export const useAddressDispatch = () => useContext(AddressDispatchContext);
